module.exports = __webpack_public_path__ + "img/Apple.84122f49.png";